<template>
  <div class="order-content">

    <div class="modal" id="document-items" tabindex="-1" v-if="selectedCart">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ selectedCart.title }}</h5>
          </div>
          <div class="modal-body">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ translations.ord.toUpperCase() }}.</th>
                  <th>{{ translations.tables.name.toUpperCase() }}</th>
                  <th>{{ translations.quantity2 }}</th>
                  <th>{{ translations.price2 }}</th>
                  <th>{{ translations.total.toUpperCase() }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in selectedCart.documentItems"
                  :key="item.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.totalAmount / item.quantity | money3 }} KM</td>
                  <td>{{ item.totalAmount | money3 }} KM</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary mr-0" @click="showCreateOrderModal()">
              {{ translations.repeatOrder}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="confirm-clear-cart" tabindex="-1" v-if="selectedCart">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p>{{translations.areYourSureEmptyShoppingCart}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="clearCart()">
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="closeConfirmationModal()"
            >
            {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="confirm-add-to-cart" tabindex="-1" v-if="selectedCart">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              {{translations.shoppingCartNotConcluded}}
              {{translations.shoppingCartItemsReplacement}}
            </p>
            <p>
              {{translations.doYouWantToContinue}}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="addItemsToShoppingCart()">
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="closeConfirmationAddToCartModal()"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <h3 class="account-sub-title d-none d-md-block">
      <i class="sicon-social-dropbox align-middle mr-3"></i>
      {{ translations.shoppingCarts }}
    </h3>
    <div class="order-table-container order-table-with-content">
      <table class="table table-order text-left">
        <thead>
          <tr>
            <th class="order-id">{{ translations.ord.toUpperCase() }}.</th>
            <th class="order-date">{{ translations.tables.name.toUpperCase() }}</th>
            <th class="order-status">{{ translations.description.toUpperCase() }}</th>
            <th class="order-price">{{ translations.total.toUpperCase() }}</th>
            <th class="order-action">{{ translations.actions.toUpperCase() }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="carts.length === 0">
            <td class="text-center p-0" colspan="5">
              <p class="mb-5 mt-5">{{translations.thereAreCurrentlyNoSavedShoppingCarts}}</p>
            </td>
          </tr>
          <tr class="pending-order" v-for="(item, index) in carts" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.totalAmount | money3WithCurrency }}</td>
            <td class="order-actions">
              <a href="#" title="Prikaži stavke" @click.prevent.stop="showDocumentItems(item)">
                <i class="fas fa-external-link-alt"></i>
              </a>
              <a
                href="#"
                title="Ponovi istu narudžbu"
                @click.prevent.stop="showDeleteShoppingCartModal(item)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination :action="actionName" :pagination-props="paginationsProps"/>
      <hr class="mt-0 mb-3 pb-2" v-if="carts.length === 0" />
      <router-link exact :to="{ name: 'Home' }" class="btn btn-primary">
        {{ translations.continueShopping }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';

import config from '@/config';
import api from '@/services/api';
import { pager, translations } from '@/mixins';
import Pagination from '@/components/shared/Pagination.vue';

export default {
  name: 'ShoppingCards',
  mixins: [pager, translations],
  components: {
    Pagination,
  },
  data() {
    return {
      actionName: 'getShoppingCarts',
      selectedCart: null,
    };
  },
  computed: {
    carts() {
      return this.$store.getters.getShoppingCarts;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    baseUrl() {
      return config.baseUrl;
    },
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    paginationsProps() {
      return {
        ...this.searchConfig,
        documentTypeId: 6,
        userId: this.loggedUser.userId,
      };
    },
  },
  methods: {
    format(dateString) {
      return format(new Date(dateString), 'dd.MM.yyyy H:mm');
    },
    showDocumentItems(cart) {
      this.selectedCart = cart;
      setTimeout(() => {
        $('#document-items').modal('show');
      }, 0);
    },
    addItemsToShoppingCart() {
      api.createShoppingCartFromDocuments(this.selectedCart.id).then(() => {
        $('#document-items').modal('hide');
        $('#confirm-add-to-cart').modal('hide');
        this.$router.push({ name: 'ShoppingCart' });
      }).catch((err) => {
        $('#document-items').modal('hide');
        this.$toast.error(err.response.data.info);
      });
    },
    showDeleteShoppingCartModal(cart) {
      this.selectedCart = cart;
      setTimeout(() => {
        $('#confirm-clear-cart').modal('show');
      }, 0);
    },
    clearCart() {
      api.deleteSavedShoppingCarts([this.selectedCart.id]).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch(this.actionName,
          { ...this.searchConfig, documentTypeId: 6, userId: this.loggedUser.userId });
        this.closeConfirmationModal();
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
        this.closeConfirmationModal();
      });
    },
    closeConfirmationModal() {
      $('#confirm-clear-cart').modal('hide');
    },
    closeAddToCartConfirmationModal() {
      $('#confirm-add-to-cart').modal('hide');
    },
    showCreateOrderModal() {
      $('#document-items').modal('hide');

      const { cart } = this;

      if (cart?.cartItems?.length) {
        setTimeout(() => {
          $('#confirm-add-to-cart').modal('show');
        }, 50);
      } else {
        this.addItemsToShoppingCart();
      }
    },
    closeConfirmationAddToCartModal() {
      $('#confirm-add-to-cart').modal('hide');
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch(this.actionName,
      { ...this.searchConfig, documentTypeId: 6, userId: this.loggedUser.userId });
  },
};
</script>

<style lang="scss">
:root {
  --v-calendar-view-button-font-size: 1.5rem;
  --v-calendar-day-font-size: 1.2rem;
  --v-calendar-input-font-size: 1.5rem;
  --v-calendar-day-name-font-size: 1.1rem;
  --v-calendar-year-font-size: 1.2rem;
  --v-calendar-month-font-size: 1.3rem;
  --v-calendar-range-bg-color: #ebf4f8;
  --v-calendar-range-text-color: #000;
  --v-calendar-active-bg-color: #357dbd;
  --v-calendar-day-height: 35px;
  --v-calendar-datepicker-icon-color: #1e84bc;
  --v-calendar-datepicker-icon-size: 1.5rem;
}

.attribute-style-1 {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-bottom: -5px;
}

#order-confirmation {
  z-index: 1100;
}

.date-range-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
